import {AbstractRepository} from "./AbstractRepository";
import { saveAs } from 'file-saver';
import 'core-js/es6/array';
import {importDB, exportDB} from "dexie-export-import";

export class ExportRepository extends AbstractRepository {

    constructor() {
        super();
    }

    export(key) {

        const blob = exportDB(this, {prettyJson: true});

        blob.then(function(result){
            var fileName = 'export.json';
            var fileToSave = new Blob([result], {
                type: 'application/json',
                name: fileName
            });
            saveAs(fileToSave, fileName);
        });

        return true;
    }

    import(key, file) {
        this.delete().then(() => {
            console.log("Database successfully deleted");
            let importPromise = importDB( file, {
                progressCallback
            });

            importPromise.then(function () {
                console.log('Import erfolgreich');
            });
        }).catch((err) => {
            console.error("Could not delete database");
        }).finally(() => {
            // Do what should be done next...
        });


        function progressCallback ({totalRows, completedRows}) {
            console.log(`Progress: ${completedRows} of ${totalRows} rows completed`);
        }

        return true;
    }
}